// extracted by mini-css-extract-plugin
module.exports = {"expandBtn":"PatientNames_expandBtn__b7UO7"};